
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Download } from 'lucide-react';

export const DisclosuresTab = () => {
  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-center">
          <CardTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-orange-500" />
            Disclosures & Attestations
          </CardTitle>
          <Button variant="outline" size="sm" className="flex items-center gap-2">
            <Download className="h-4 w-4" />
            Export
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="p-4 bg-gray-50 rounded-lg">
            <div className="text-sm text-gray-500 mb-1">OBA Disclosures</div>
            <div className="text-2xl font-semibold">7</div>
            <div className="text-xs text-green-600 mt-1">All up to date</div>
          </div>
          <div className="p-4 bg-gray-50 rounded-lg">
            <div className="text-sm text-gray-500 mb-1">Gift Reports</div>
            <div className="text-2xl font-semibold">12</div>
            <div className="text-xs text-yellow-600 mt-1">2 pending review</div>
          </div>
          <div className="p-4 bg-gray-50 rounded-lg">
            <div className="text-sm text-gray-500 mb-1">Political Contributions</div>
            <div className="text-2xl font-semibold">3</div>
            <div className="text-xs text-blue-600 mt-1">1 needs approval</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
